export const useDocumentHeadersStore = (documentId: string) => {
  const { revision } = useSubmittedDocumentStore(documentId);

  if (!revision) {
    throw new Error("Revision is not defined");
  }

  return useDocumentHeaders(documentId, revision.id)();
};
